import { render, staticRenderFns } from "./bottom-icon.vue?vue&type=template&id=05da1da7&scoped=true&"
import script from "./bottom-icon.vue?vue&type=script&lang=js&"
export * from "./bottom-icon.vue?vue&type=script&lang=js&"
import style0 from "./bottom-icon.vue?vue&type=style&index=0&id=05da1da7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05da1da7",
  null
  
)

export default component.exports